import React, { FC, useEffect } from 'react'
import { useParams } from 'infrastructure/routing'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { singleResourceIdAtom } from '../../api/singleQueries'
import {
  type ResourceKey,
  resourceKeyAtom,
} from '../../components/resources/resourceList/atoms'

export function withIdParam(
  resourceKey: string,
  component: FC<{ id: string; resourceKey: string }>,
) {
  return <WithId resourceKey={resourceKey} component={component} />
}

function WithId({
  resourceKey,
  component: Component,
}: {
  resourceKey: string
  component: FC<{ id: string; resourceKey: string }>
}) {
  const { id } = useParams()
  const singleSetter = useSetAtom(singleResourceIdAtom)
  useEffect(() => {
    if (id) {
      singleSetter({ id: parseInt(id), resourceKey })
    } else {
      singleSetter({ id, resourceKey })
    }
  }, [resourceKey, id, singleSetter])

  if (!id) return null

  return <Component id={id} resourceKey={resourceKey} />
}

export function WithResourceId({
  resourceKey,
  component: Component,
}: {
  resourceKey: ResourceKey
  component: FC
}) {
  useSetAtom(resourceKeyAtom)(resourceKey)
  return <Component />
}
